import { environment } from '../environments/environment';

export const Config = {
    BASE_API_URL_V1: environment.API_ROOT + "/api/v1",
    LOGO_URL: "https://taylorinstitute.ucalgary.ca/curriculum-links",
    DEBUG: environment.production ? false : true

}